import { Alert } from '@apollo/orbit';
import React from 'react';

import type { BuildGraphQLSchemaError } from './BuildGraphQLSchemaError';

export const BuildGraphQLSchemaErrorPrompt = ({
  error,
}: {
  error: BuildGraphQLSchemaError;
}) => (
  <div>
    <h2 className="mb-2">Error Building schema</h2>
    <Alert className="mb-4" status="error">
      {error.message}
    </Alert>
    <p>
      We encountered errors attempting to build a schema from the following SDL:
    </p>
    <code
      className="max-w-lg overflow-auto whitespace-pre text-left font-mono text-sm"
      style={{ maxHeight: 300 }}
    >
      {error.sdl}
    </code>
    <p>Please try addressing the errors and register a new schema</p>
  </div>
);
